<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <br /><br />
        <Caption label="조직도" />
        <br />
        <div class="text1">T-Relation</div>
        <div class="text2">
          각 조직은 수평적 관계를 지향하며, 각 조직의 리더는 관리형(Tree)이 아닌
          실무형(T)으로서 그 조직의 상부가 아닌 중심에 있습니다 각 부서 혹은
          고유 권한을 가지며, 그 권한은 고유하며, 권한과 책임은 동일합니다
        </div>
        <br />
        <div class="text1">Conversion</div>
        <div class="text2">
          모든 구성원은 FullStack(PM, 기획 디자인, 개발, QA)을 지향하며 PL은
          관리 역할이 아닌 모든 부문을 수행 가능한 실무형 입니다
        </div>

        <img class="image" src="@/assets/images/tree.png" />
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding-top: 30px;
  padding-bottom: 30px;
  z-index: 1;
  /* background-color: #f00; */
}

.text1 {
  padding-left: 230px;
  padding-right: 230px;
  font-size: 14px;
  font-weight: bold;
  color: #215fe6;
  text-align: left;
}
.text2 {
  padding-left: 230px;
  padding-right: 230px;
  font-size: 14px;
  color: #215fe6;
  text-align: left;
}
.image {
  margin-top: 100px;
  width: 917px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding-top: 30px;
    padding-bottom: 30px;
    z-index: 1;
    /* background-color: #f00; */
  }

  .text1 {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #215fe6;
    text-align: left;
  }
  .text2 {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    color: #215fe6;
    text-align: left;
  }
  .image {
    margin-top: 50px;
    width: 90vw;
  }
}
</style>
  